import React from "react";
import silhouette from "../../../images/headshot-silhouette-30.png";

interface AccountProfilePhotoProps {
  account_profile_image_url: string | null;
}

const AccountProfilePhoto: React.FC<AccountProfilePhotoProps> = ({
  account_profile_image_url,
}) => {
  return (
    <div className="dashboard-profile-banner-circle-container">
      <div className="dashboard-profile-banner-outer-circle">
        <div className="dashboard-profile-banner-inner-circle">
          <img
            src={account_profile_image_url || silhouette}
            alt="Account Profile Photo"
            className="dashboard-profile-banner-profile-picture"
            onError={(e) => {
              e.currentTarget.src = silhouette;
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountProfilePhoto;
